'use client';

import NextError from 'next/error';
import { useEffect, useState } from 'react';
import { unstable_isUnrecognizedActionError } from 'next/navigation';
import { CLIENT_EVENT, logClientEvent } from '@/app/lib/datadog/client-config';
import { consumePendingServerActionSkew, peekPendingServerActionSkew } from '@/app/lib/serverActionSkew';
import { ServerActionSkewReloadView } from '@/app/ui/ServerActionSkewDialog';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
	const [showSkew, setShowSkew] = useState(
		() => unstable_isUnrecognizedActionError(error) || peekPendingServerActionSkew() !== null,
	);

	useEffect(() => {
		console.error(error);
		const pending = consumePendingServerActionSkew();
		const isSkew = unstable_isUnrecognizedActionError(error) || pending !== null;
		if (!isSkew) return;
		setShowSkew(true);
		logClientEvent(CLIENT_EVENT.SERVER_ACTION_SKEW, pending ?? undefined, 'warn');
	}, [error]);

	if (showSkew) {
		return (
			<html lang="en">
				<body>
					<div className="flex min-h-screen items-center justify-center bg-primary-background p-6">
						<ServerActionSkewReloadView />
					</div>
				</body>
			</html>
		);
	}

	return (
		<html lang="en">
			<body>
				<NextError statusCode={0} />
			</body>
		</html>
	);
}
